import React from "react";
import { Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { NotImplemented } from "pages/PayRoll/Shared/NotImplemented";
import { useReimbursementSettings } from "pages/PayRoll/Shared/reimbursementApi";

// Placeholder until Reimbursements is built. Reached from
// Payroll > Pay Inputs > Reimbursements in the sidebar flyout. When
// Enable Reimbursements is off (Payroll Settings > Pay Input), the row is
// hidden from the flyout and this URL moves on to the next Pay Inputs
// screen, like the other pay inputs.
export const PayInputReimbursements = () => {
  const { domain, topbarCompanyId } = useSelector((state) => state.tokenReducer);
  const { enabled } = useReimbursementSettings(domain, topbarCompanyId);
  if (!enabled) return <Redirect to="/admin/payroll/pay-inputs/penalties" />;
  return <NotImplemented title="Reimbursements" />;
};
